import { useDispatch } from "ko-data-store";
import { isLoading } from "../../../dataStore/actions/appUI";
import RateService, { TPIRateRequest } from "../../../services/RateService";
import template from "./tpi-view-rates-modal-component.html";
import queryCache from "../../../utils/queryCache";

export interface ITPIRateRequest {
    loadId: number | undefined,
    orderId: number | undefined,
    originCity: string | undefined,
    originState: string | undefined,
    originZip: string | undefined,
    destinationCity: string | undefined,
    destinationState: string | undefined,
    destinationZip: string | undefined,
    trailerType: string,
    pickupDate: string | undefined,
    requestType: string | "ORDER" | "LOAD" | "LOADBOARD",
    transportationMode: string,
    skipStoringResult: boolean,
    externalBoardNames: string[],
}


export interface TPIViewRatesModalViewModelProps {
  request: ITPIRateRequest;
  forceRefresh?: boolean;
  onClose?: () => void;
}


class TPIViewRatesModalViewModel {
  dispatch = useDispatch();
  props: TPIViewRatesModalViewModelProps;
  rateRequest: ITPIRateRequest = TPIRateRequest();
  rates: ko.ObservableArray<any> = ko.observableArray([]);
  errors: ko.ObservableArray<any> = ko.observableArray([]);
  showModal = ko.observable(false);

  constructor({ props }: { props: TPIViewRatesModalViewModelProps }) {
    this.rateRequest = props.request;
    this.props = props;
    
    this.loadData().then(() => {
      this.showModal(true);
    });
  }

  loadData = async () => {
    if(this.props.request.requestType === "LOAD") {
      await this.getSavedRatesForLoad(this.props.request.loadId, this.props.forceRefresh);
    }
    else if(this.props.request.requestType === "ORDER") {
      await this.getSavedRatesForOrder(this.props.request.orderId, this.props.forceRefresh);
    }
    else {
      await this.getRates();
    }
  }

  handleOnClose = () => {
    this.dispose();
    if (this.props.onClose) {
      this.props.onClose();
    }
  }

  handleOnRefreshRates = async () => {
    this.props.forceRefresh = true;
    this.loadData();
  }

  getRates = async () => {
    try {
      this.errors([]);

      this.rateRequest.transportationMode = this.rateRequest.transportationMode || "TL";

      this.dispatch(isLoading(true));
      const response = await RateService.getTPIRates(this.rateRequest);

      this.rates(response.rates || []);
      this.errors(response.errors || []);
    }
    catch (error) {
      console.error("Error fetching TPI rates:", error);
    }
    finally {
      this.dispatch(isLoading(false));
    }
  }

  getSavedRatesForOrder = async (orderId: number, forceRefresh?: boolean) => {
    try {
      this.errors([]);

      this.dispatch(isLoading(true));
      const response = await RateService.getSavedRatesForOrder(orderId, forceRefresh ?? false);
    
      this.rates(response.rates || []);
      this.errors(response.errors || []);

    }
    catch (error) {
      console.error("Error fetching TPI rates:", error);
    }
    finally {
      this.dispatch(isLoading(false));
    }
    
  }

  getSavedRatesForLoad = async (loadId: number, forceRefresh?: boolean) => {
    try {
      this.errors([]);

      this.dispatch(isLoading(true));
      const response = await RateService.getSavedRatesForLoad(loadId, forceRefresh ?? false);
    
      this.rates(response.rates || []);
      this.errors(response.errors || []);
    }
    catch (error) {
      console.error("Error fetching TPI rates:", error);
    }
    finally {
      this.dispatch(isLoading(false));
    }
  }

  dispose = () => {
    this.showModal(false);
    this.rates([]);
    this.errors([]);
    this.props.forceRefresh = false;
  }
}

export default { viewModel: TPIViewRatesModalViewModel, template };
